var _circle, _circle2, _rect, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaterial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.167,
    cy: 32,
    r: 31.5,
    fill: "white",
    stroke: "#FCD1C1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.167,
    cy: 32,
    r: 28,
    fill: "#FCD1C1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40.167,
    y: 40,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#F46530"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.1667 45.334C48.4867 45.334 45.5 48.3207 45.5 52.0007C45.5 55.6807 48.4867 58.6673 52.1667 58.6673C55.8467 58.6673 58.8333 55.6807 58.8333 52.0007C58.8333 48.3207 55.8467 45.334 52.1667 45.334ZM49.9867 49.1073C50.5267 49.1073 50.9733 49.5473 50.9733 50.094C50.9733 50.634 50.5333 51.0807 49.9867 51.0807C49.4467 51.0807 49 50.6407 49 50.094C49 49.5473 49.44 49.1073 49.9867 49.1073ZM50.0667 54.534C49.9667 54.634 49.84 54.6807 49.7133 54.6807C49.5867 54.6807 49.46 54.634 49.36 54.534C49.1667 54.3407 49.1667 54.0207 49.36 53.8273L53.7267 49.4607C53.92 49.2673 54.24 49.2673 54.4333 49.4607C54.6267 49.654 54.6267 49.974 54.4333 50.1673L50.0667 54.534ZM54.3467 54.894C53.8067 54.894 53.36 54.454 53.36 53.9073C53.36 53.3673 53.8 52.9207 54.3467 52.9207C54.8867 52.9207 55.3333 53.3607 55.3333 53.9073C55.3333 54.454 54.8933 54.894 54.3467 54.894Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_164_13611)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_164_13611)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.834 44V22.6667C22.834 21.9594 23.1149 21.2811 23.615 20.781C24.1151 20.281 24.7934 20 25.5007 20H38.834C39.5412 20 40.2195 20.281 40.7196 20.781C41.2197 21.2811 41.5007 21.9594 41.5007 22.6667V44L37.5007 41.3333L34.834 44L32.1673 41.3333L29.5007 44L26.834 41.3333L22.834 44Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.834 44V22.6667C22.834 21.9594 23.1149 21.2811 23.615 20.781C24.1151 20.281 24.7934 20 25.5007 20H38.834C39.5412 20 40.2195 20.281 40.7196 20.781C41.2197 21.2811 41.5007 21.9594 41.5007 22.6667V44L37.5007 41.3333L34.834 44L32.1673 41.3333L29.5007 44L26.834 41.3333L22.834 44Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_164_13611)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.8333 26.666H31.5C30.9696 26.666 30.4609 26.8767 30.0858 27.2518C29.7107 27.6269 29.5 28.1356 29.5 28.666C29.5 29.1964 29.7107 29.7052 30.0858 30.0802C30.4609 30.4553 30.9696 30.666 31.5 30.666H32.8333C33.3638 30.666 33.8725 30.8767 34.2475 31.2518C34.6226 31.6269 34.8333 32.1356 34.8333 32.666C34.8333 33.1964 34.6226 33.7052 34.2475 34.0802C33.8725 34.4553 33.3638 34.666 32.8333 34.666H29.5M32.1667 34.666V36.666M32.1667 24.666V26.666",
    stroke: "#F46530",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    shapeRendering: "crispEdges"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_164_13611",
    x: 19.834,
    y: 17,
    width: 28.667,
    height: 34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.439216 0 0 0 0 0.396078 0 0 0 0 0.941176 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_164_13611"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_164_13611",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_164_13611",
    x: 26.5,
    y: 21.666,
    width: 15.333,
    height: 22,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.439216 0 0 0 0 0.396078 0 0 0 0 0.941176 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_164_13611"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_164_13611",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_164_13611"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(16.167 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterial);
export default __webpack_public_path__ + "static/media/material.6001f259006acca65ea5cd5cbf67fb71.svg";
export { ForwardRef as ReactComponent };